import PropTypes from 'prop-types';

export const childrenPropType = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node,
]);

export const filterableCategoryPropType = {
  checked: PropTypes.bool,
  dark: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export const locationsPropType = PropTypes.arrayOf(PropTypes.shape({
  locationId: PropTypes.string.isRequired,
  xCoord: PropTypes.number.isRequired,
  yCoord: PropTypes.number.isRequired,
}).isRequired);

export const ticketsPropType = PropTypes.arrayOf(PropTypes.shape({
  accessibilityAccess: PropTypes.bool.isRequired,
  days: PropTypes.arrayOf(PropTypes.shape({
    bookLink: PropTypes.string.isRequired,
    detailsLink: PropTypes.string.isRequired,
    eventId: PropTypes.string.isRequired,
    dynamicPricing: PropTypes.bool.isRequired,
    fallbackStatus: PropTypes.shape({
      showLink: PropTypes.bool.isRequired,
      status: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      useFallback: PropTypes.bool,
    }).isRequired,
    id: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
  }).isRequired).isRequired,
  location: PropTypes.string.isRequired,
  locationCoordinates: PropTypes.shape({
    xCoord: PropTypes.number.isRequired,
    yCoord: PropTypes.number.isRequired,
  }).isRequired,
  locationId: PropTypes.string.isRequired,
  ticketCategory: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}).isRequired);
